import { makeStyles, theme } from "cdh-data-portal-theme"

export const useStyles = makeStyles()(() => ({
  root: {
    background: theme.colors.globalBackgroundLight,
    borderRadius: 8,
    boxShadow: theme.shadows.medium,
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 8,
    padding: 24,
  },
  count: {
    "&&": {
      fontWeight: 500,
    },
  },
}))
